import { CALL_SWITCH_REQ_WAITING } from '../../../constants';
import { useVideoCallSwitchPopup } from '../../../viewmodels';
import { AlertModalItem } from '@/components/AlertModalRoot';

const VideoCallSwitchPopup = () => {
   const { showPopup, callSwitchData, switchAction, handleSwitchAction } = useVideoCallSwitchPopup();

   if (!showPopup) return null;

   const modalConfig = {
      id: 'video-call-switch-modal',
      title: callSwitchData?.content,
      visible: showPopup,
      noButton: callSwitchData?.cancelBtnLabel,
      noAction: () => handleSwitchAction(callSwitchData?.cancelStatusToUpdate),
      yesButton: switchAction !== CALL_SWITCH_REQ_WAITING ? callSwitchData?.confirmBtnLabel : null,
      yesAction: () => handleSwitchAction(callSwitchData?.confirmStatusToUpdate),
   };

   return <AlertModalItem modal={modalConfig} onRemove={() => {}} />;
};

export default VideoCallSwitchPopup;
